import React, { type FC, type PropsWithChildren } from 'react';

import { sendBeaconEvent } from '@lucid/utils';

import type { Lucid } from '../../types/types';
import Link from '../link/link';
import Image from '../image/image';
import defaultIcons from './data/socialIconData.json';
import eduIcons from './data/socialIconDataEdu.json';

export interface SocialIconSectionProps {
  /** Allows the component to get additional styles. */
  className?: string;
  product?: Lucid.Product.Sites;
}

const SocialIconSection: FC<PropsWithChildren<SocialIconSectionProps>> = ({ className, product, ...rest }) => {
  const icons = product === 'edu' ? eduIcons : defaultIcons;

  const handleIconClick = (name: string) => {
    sendBeaconEvent({
      name: 'clickedMarketingPageElement',
      elementLocation: 'footer',
      elementDetail: name,
      elementType: 'link',
    });
  };

  return (
    <ul
      {...rest}
      css={theme => ({
        display: 'flex',
        listStyle: 'none',
        gap: theme.space.s32,
        justifyContent: 'flex-end',
        flexGrow: 1,
        flexShrink: 0,
        margin: 0,
      })}
      // eslint-disable-next-line react/jsx-sort-props
      className={className}
    >
      {icons?.map((socialIcon, index) => (
        <li key={`footerSocialLink-${index + 1}`}>
          <Link
            aria-label={socialIcon?.label}
            onClick={() => handleIconClick(socialIcon?.name || '')}
            rel="noreferrer"
            target="_blank"
            to={socialIcon?.url!}
          >
            <Image
              css={{ height: '20px', width: '20px' }}
              dataElementPageLocation="bottomFooter"
              imageAlt={socialIcon?.name! || ''}
              imageSrc={socialIcon?.logo!}
              loading="lazy"
            />
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SocialIconSection;
